import sget from 'xlvip-sget'
import dayjs from 'dayjs'
import * as util from '~/utils/$util'

export default ({ error, store }, inject) => {
  inject('sget', sget)
  inject('util', util)
  inject('dayjs', dayjs)
  inject('login', () => store.commit('app/setLoginPop', true))
  inject('error', (err) => {
    error(err || {})
  })
}
